import  MapService from './MapService';
export default MapService
